// ABOUTME: Hook that syncs PostHog user identity with Clerk auth state.
// ABOUTME: Calls identify on sign-in, reset on sign-out, and tracks new signups.
import { useEffect, useRef } from 'react'
import { useUser } from '@clerk/react'
import posthog from 'posthog-js'
import { trackSignupCompleted } from './events'

export function useIdentify(): void {
  const { user } = useUser()
  const wasIdentifiedRef = useRef(false)
  const signupTrackedRef = useRef(false)

  useEffect(() => {
    if (user) {
      posthog.identify(user.id, {
        ...(user.primaryEmailAddress?.emailAddress
          ? { email: user.primaryEmailAddress.emailAddress }
          : {}),
      })
      wasIdentifiedRef.current = true

      if (!signupTrackedRef.current) {
        const ageMs = user.createdAt ? Date.now() - user.createdAt.getTime() : Infinity
        if (ageMs < 60_000) {
          trackSignupCompleted(user.id)
          signupTrackedRef.current = true
        }
      }
    } else {
      if (wasIdentifiedRef.current) {
        posthog.reset()
        wasIdentifiedRef.current = false
      }
    }
  }, [user])
}
